<template>
  <div v-if="broker != null" class="w-full lg:w-1/2">

    <div class="text-lg">Mail Settings</div>

    <div class="mt-3 text-sm text-gray-700">
      The following settings are applied by default whenever you send an email to a client.
      You can also change the settings for each client just before the email is sent.
    </div>

    <div class="my-8 ">
      
      <!-- this needs to go... -->
      <template v-if="broker.mailto == 1">
        <div class="label-standard">Send emails to clients from</div>

        <div class="radio-line flex items-center">
          <InputRadio
            name="inputEmail"
            id="inputEmailBp"
            propertyKey="mailto"
            value="0"
            :checked="broker.mailto == 0"
            :updateValue="updateValue" />

          <label class="text-base ml-2 mr-8" for="inputEmailBp">{{ getAppName }}</label>

          <InputRadio
            name="inputEmail"
            id="inputEmailOwn"
            propertyKey="mailto"
            value="1"
            :checked="broker.mailto == 1"
            :updateValue="updateValue" />

          <label class="text-base ml-2" for="inputEmailOwn">My email client</label>
        </div>
      </template>

      <template v-if="broker.mailto == 0">

        <div class="label-line label-standard">
          Expire email link in
        </div>

        <div class="form-line">
          <select class="select-standard" :value="emailLinkExpiresIn" 
            @change="updateValue({
              key : 'email_link_expires_in', 
              value : $event.target.value
            })">
            <option value="2">2 days</option>
            <option value="3">3 days</option>
            <option value="4">4 days</option>
            <option value="5">5 days</option>
            <option value="6">6 days</option>
            <option value="7">7 days</option>
            <option value="8">8 days</option>
            <option value="9">9 days</option>
            <option value="10">10 days</option>
            <option value="11">11 days</option>
            <option value="12">12 days</option>
            <option value="13">13 days</option>
            <option value="14">14 days</option>
            <option value="15">15 days</option>
            <option value="16">16 days</option>
            <option value="17">17 days</option>
            <option value="18">18 days</option>
            <option value="19">19 days</option>
            <option value="20">20 days</option>
            <option value="21">21 days</option>
            <option value="22">22 days</option>
            <option value="23">23 days</option>
            <option value="24">24 days</option>
            <option value="25">25 days</option>
            <option value="26">26 days</option>
            <option value="27">27 days</option>
            <option value="28">28 days</option>
            <option value="29">29 days</option>
            <option value="30">30 days</option>
          </select>
        </div>



        <div class="label-line label-standard">
          Send a reminder email to client if they don't respond in
        </div>

        <div class="form-line">
          <select class="select-standard" :value="sendReminderIn" 
            @change="updateValue({
              key : 'send_reminder_in', 
              value : $event.target.value
            })">
            <option value="2">2 days</option>
            <option value="3">3 days</option>
            <option value="4">4 days</option>
            <option value="5">5 days</option>
            <option value="6">6 days</option>
            <option value="7">7 days</option>
            <option value="8">8 days</option>
            <option value="9">9 days</option>
            <option value="10">10 days</option>
            <option value="11">11 days</option>
            <option value="12">12 days</option>
            <option value="13">13 days</option>
            <option value="14">14 days</option>
            <option value="15">15 days</option>
            <option value="16">16 days</option>
            <option value="17">17 days</option>
            <option value="18">18 days</option>
            <option value="19">19 days</option>
            <option value="20">20 days</option>
            <option value="21">21 days</option>
            <option value="22">22 days</option>
            <option value="23">23 days</option>
            <option value="24">24 days</option>
            <option value="25">25 days</option>
            <option value="26">26 days</option>
            <option value="27">27 days</option>
            <option value="28">28 days</option>
            <option value="29">29 days</option>
            <option value="30">30 days</option>
          </select>
        </div>



        <div class="label-line text-lg font-light">Email Content</div>

        <div class="mt-4 label-standard">Subject</div>

        <div class="form-line">
          <input type="text" class="input-standard" 
            v-model="subject" 
            v-on:blur="updateValue({
              key  : 'email_subject',
              value: $event.target.value
            })" />
          <div v-if="subjectError != null" class="mt-2 text-red-600">{{ subjectError }}</div>
        </div>

        <div class="label-line flex items-center">
          <div class="label-standard">
            Personal message included in email sent to clients
          </div>
          <span class="mx-3 text-gray-400">/</span>
          <a href="#"
            class="no-underline text-red-600 hover:underline"
            style="margin-top:2px;"
            @click.prevent="resetPersonalMessage">Reset to default</a>
        </div>

        <div class="form-line">
          <textarea
            class="input-standard"
            style="height:150px;"
            :value="broker.personal_message"
            v-on:blur="updateValue({
              key  : 'personal_message', 
              value: $event.target.value
            })"></textarea>
        </div>

        <div class="label-line label-standard">
          Email disclaimer - <span class="text-gray-600">This is appended at the end of each email.</span>
        </div>

        <div class="form-line">
          <textarea
            class="input-standard"
            style="height:150px;"
            :value="broker.email_disclaimer"
            v-on:blur="updateValue({
              key  : 'email_disclaimer', 
              value: $event.target.value
            })"></textarea>
        </div>



        <div class="mt-10 text-lg font-light">
          Attachments

          <label for="inputFileNewAttachment" class="ml-8 font-normal text-sm text-blue-600 hover:underline cursor-pointer">Add attachment</label>
          <input class="hidden" ref="inputFile" id="inputFileNewAttachment" type="file" v-on:change="uploadBrokerAttachment($event)"/>
        </div>

        <template v-if="attachments == null"></template>

        <template v-else>
          <template v-if="attachments.length > 0">
            <template v-for="(attachment, index) in attachments">
              <div class="mt-2 bg-gray-200 p-4 flex items-center justify-between rounded">
                <div class="flex items-center">
                  <svg width="16" height="16" stroke-width="2" stroke="currentColor" fill="none">
                    <use xlink:href="/static/img/feather-sprite.svg#paperclip"/>
                  </svg>

                  <a :href="attachment.url" target="_blank" class="ml-2 underline">{{ attachment.file_name }}</a>
                </div>

                <a href="#"
                  class="text-red-500 no-underline hover:underline"
                  @click.prevent="deleteBrokerAttachment(attachment.id, index)">Delete</a>
              </div>
            </template>
          </template>

          <template v-else>
            <label
              for="inputFileNewAttachment"
              class="mt-4 p-2 bg-red-100 border border-red-500 text-sm text-gray-800 rounded block cursor-pointer">
              <div class="text-gray-700 text-sm p-3">
                You haven't added any attachments. Click here to add.
              </div>
            </label>
          </template>
        </template>
      </template>

    </div>
    <br/><br/><br/>
    <AutoSaveLoader :autoSaving="autoSaving" />
  </div>
</template>

<script>
  import axios          from 'axios'
  import InputRadio     from '@/shared/components/form/InputRadio'
  import TextareaField  from '@/shared/components/form/TextareaField'
  import { EventBus }   from '@/shared/event-bus'
  import AutoSaveLoader from '@/shared/components/loaders/AutoSaveLoader'

  export default {

    components: {
      TextareaField,
      InputRadio,
      AutoSaveLoader
    },

    data () {
      return {
        loading     : false,
        autoSaving  : false,
        broker      : null,
        attachments : null,
        subjectError: null
      }
    },

    mounted() {
      EventBus.$on('set-autosave', trueOrFalse => {
        this.autoSaving = trueOrFalse
      });
    },

    destroyed() {
      EventBus.$off('set-autosave')
    },

    created() {
      this.getCurrentBroker()
    },

    computed : {
      emailLinkExpiresIn : {
        get() {
          if(this.broker.email_link_expires_in == null) {
            return 10
          }

          else {
            return this.broker.email_link_expires_in
          }
        },

        set(value) {
          this.broker.email_link_expires_in = value
        }
      },

      sendReminderIn : {
        get() {
          if(this.broker.send_reminder_in == null) {
            return 5
          }

          else {
            return this.broker.send_reminder_in
          }
        },

        set(value) {
          this.broker.send_reminder_in = value
        }
      },

      subject : {
        get() {
          if(this.broker.email_subject == null) {
            return this.broker.first_name + " " + this.broker.last_name + " has an application for you to complete"
          }

          else {
            return this.broker.email_subject
          }
        },

        // don't do anything since we are going to auto-save and compare values
        set(value) {
          // this.broker.email_subject = value
        }
      }
    },

    methods : {
      getCurrentBroker() {
        this.getBroker({
          userId: this.$store.state.user.id,
          force : true
        }, (broker) => {
          this.broker = _.cloneDeep(broker)
          this.getAttachments()
        })
      },

      resetPersonalMessage() {
        this.apiGet({}, 'broker/default-personal-message', (message) => {
          this.broker.personal_message = message
          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'Message reset successfully.'
          })
        })
      },

      getAttachments() {
        this.apiGet({
          brokerId : this.broker.id
        }, 'broker/attachments', (attachments) => {
          this.attachments = attachments
        })
      },

      updateValue(params) {
        this.updateBroker(this.broker, params.key, params.value)
      },

      uploadBrokerAttachment($event) {
        let file     = $event.target.files[0] || $event.dataTransfer.files[0]
        let formData = new FormData()
        formData.append('file', file)
        this.showLoader("Uploading...")
        axios.post(process.env.VUE_APP_API_URL + '/api/broker/upload-attachment', formData, {
          headers: {
            'Content-Type'  : 'multipart/form-data',
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.hideLoader()
          this.attachments.push(response.data)
          this.$refs.inputFile.value = null
        }).catch(function(err) {

        });
      },

      deleteBrokerAttachment(attachmentId, index) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                fileId : attachmentId
              }, 'broker/delete-attachment', () => {
                this.$modal.hide('confirm-modal')
                this.attachments.splice(index, 1)
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    },
  }
</script>